import { useEffect, useState } from "react";
import { Field, FieldArray, Formik } from "formik";
import "../../../../assets/css/cms/Coaching.css";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { required } from "../../../../utils/validations";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiFillMinusSquare } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TiDelete } from "react-icons/ti";
import {
  deleteCoachingOtherMedia,
  getCmsCoachingCourseDropdownList,
  getCmsCoachingExams,
  getCmsCoachingToppers,
  patchCmsCoachingTopper,
  postCmsCoachingTopper,
} from "../../../../../store/actions/cms/cmsCoaching";
import { Alert } from "@mui/material";

const TopperDetailsForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [touchedForm, setTouchedForm] = useState(false);
  const [debounceState, setDebounceState] = useState(false);
  const [courseInput, setCourseInput] = useState("");
  const [examInput, setExamInput] = useState("");
  const [examsOptions, setExamOptions] = useState([])
  const [courseOptions, setCourseOptions] = useState([])

  const {
    coachingToppers,
    coachingToppersError,
    coachingExams,
    coachingExamsLoading,
    coachingCourseDropdownListLoading,
    coachingCourseDropdownList,
    message,
    post_cms_coaching_topper_failure,
    patchCmsCoachingTopperError,
    postCmsCoachingTopperLoading,
    coachingToppersLoading
  } = useSelector((state) => state?.cmsCoaching);
  const user = useSelector((state) => state?.userData?.user?.data);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (postCmsCoachingTopperLoading) {
      setLoading(postCmsCoachingTopperLoading)
    }
  }, [postCmsCoachingTopperLoading])

  useEffect(() => {
    if (coachingToppers || coachingToppersError) {
      setTimeout(() => setLoading(false), 1000)
    }
  }, [coachingToppers || coachingToppersError])

  useEffect(() => {
    if (coachingExams?.data?.length) {
      setExamOptions(coachingExams?.data)
    }
  }, [coachingExams])

  useEffect(() => {
    if (coachingCourseDropdownList?.length) {
      setCourseOptions(coachingCourseDropdownList)
    }
  }, [coachingCourseDropdownList])

  const onSearch = (value, type) => {
    let inDebounce = debounceState;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => {
      let params = {};
      params.coaching_id = id
      if (type == "exam" && examInput !== value) {
        setExamInput(value);
        params.exam_name = value;
        dispatch(getCmsCoachingExams(params));
      } else if (type == "course" && courseInput !== value) {
        setCourseInput(value);
        params.course_name = value;
        dispatch(getCmsCoachingCourseDropdownList(params));
      }
    }, 1000);
    setDebounceState(inDebounce);
  };

  const handleAddTopper = (data, topper_id) => {
    let params = {};
    params.coaching_id = id;
    params.topper_id = topper_id;
    params.is_delete = false;
    const body = new FormData();
    body.append("name", data?.student_name);
    body.append("gender", data?.student_gender?.value);
    body.append("entity_id", id);
    body.append("exam_id", data?.exam?.exam_id);
    if (data?.course_name) {
      body.append("course_id", data?.course_name?.["course_id"]);
    }
    if (data?.rank_type && data?.result_type?.id == 1) {
      body.append("rank_type", data?.rank_type?.id);
    }
    body.append("result_type", data?.result_type?.id);
    body.append("result_value", data?.result_value);
    body.append("result_year", data?.result_year?.label);
    if (data?.image && typeof data?.image !== "string") {
      body.append("topper_image", data?.image);
    }

    if (topper_id) {
      body.append("updated_by", user?.id);
      dispatch(patchCmsCoachingTopper(params, body));
    } else {
      body.append("created_by", user?.id);
      dispatch(postCmsCoachingTopper(body));
    }
  };

  const handleRemoveTopper = (data, topper_id) => {
    setTouchedForm(false);
    let body = {};
    body.name = data?.student_name;
    body.gender = data?.student_gender?.value;
    body.exam_id = data?.exam?.exam_id;
    body.course_id = data?.course_name?.["course_id"];
    body.result_type = data?.result_type?.value;
    body.rank_type = data?.rank_type?.value;
    body.result_value = data?.result_value?.value;
    body.result_year = data?.result_year?.value;
    body.image = data?.image;
    let params = {};
    // params.coaching_id = id;
    params.topper_id = topper_id;
    params.is_delete = true;
    if (topper_id) {
      dispatch(patchCmsCoachingTopper(params, body));
    }
  };

  const handleNext = () => {
    navigate(`/cms/coaching/${id}/media`);
  };

  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert
            severity={
              post_cms_coaching_topper_failure || patchCmsCoachingTopperError
                ? `error`
                : `success`
            }
          >
            {" "}
            {message}{" "}
          </Alert>
        )}
      </div>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          values.topper_data?.forEach((obj, index) => {
            errors[`form_${index}`] = {};
            if (!obj?.student_name) {
              errors[`form_${index}`].student_name = required(
                obj?.student_name
              );
            }
            if (!obj.student_gender) {
              errors[`form_${index}`].student_gender = required(
                obj.student_gender
              );
            }
            if (!obj.exam) {
              errors[`form_${index}`].exam = required(obj.exam);
            }
            // if (!obj.course_name) {
            //   errors[`form_${index}`].course_name = required(obj.course_name);
            // }
            if (!obj.result_type) {
              errors[`form_${index}`].result_type = required(obj.result_type);
            }
            if (!obj.result_value) {
              errors[`form_${index}`].result_value = required(obj.result_value);
            }
            if (!obj.result_year) {
              errors[`form_${index}`].result_year = required(obj.result_year);
            }
          });
          return errors;
        }}
        onSubmit={(values) => {
          // props.submit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <FieldArray name="topper_data">
              {({ remove, push }) => (
                <div>
                  {values.topper_data?.length > 0 &&
                    values.topper_data?.map((element, index) => (
                      <div className={"basic_details_coaching"}>
                        <div className={"examfilter"}>
                          <h5>Topper Info</h5>
                          <Row>
                            <Col>
                              <Form.Group
                                className="mb-3"
                                controlId="student_name"
                              >
                                <Form.Label>Student Name*</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`topper_data.${index}.student_name`}
                                  className={"input_pd"}
                                  value={element.student_name}
                                  onChange={(event) =>
                                    setFieldValue(
                                      `topper_data.${index}.student_name`,
                                      event.target.value
                                    )
                                  }
                                  onBlur={handleBlur}
                                />
                                {errors[`form_${index}`]?.student_name &&
                                  (touched?.topper_data?.[index]
                                    ?.student_name ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.student_name}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group
                                className="mb-3"
                                controlId="student_gender"
                              >
                                <Form.Label>Student Gender*</Form.Label>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  name={`topper_data.${index}.student_gender`}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.label}
                                  value={
                                    values.topper_data?.[index].student_gender
                                  }
                                  onBlur={() => {
                                    handleBlur({
                                      target: {
                                        name: `topper_data.${index}.student_gender`,
                                      },
                                    });
                                  }}
                                  onChange={(value) =>
                                    setFieldValue(
                                      `topper_data.${index}.student_gender`,
                                      value
                                    )
                                  }
                                  options={
                                    props.dropdownConstants?.genderOptions
                                  }
                                />
                                {errors[`form_${index}`]?.student_gender &&
                                  (touched?.topper_data?.[index]
                                    ?.student_gender ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.student_gender}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3" controlId="exam">
                                <Form.Label>Exam*</Form.Label>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  name={`topper_data.${index}.exam`}
                                  getOptionLabel={(option) => option.exam_name}
                                  getOptionValue={(option) => option.exam_short_name}
                                  onInputChange={(value) =>
                                    onSearch(value, "exam")
                                  }
                                  value={values.topper_data?.[index].exam}
                                  onBlur={() => {
                                    handleBlur({
                                      target: {
                                        name: `topper_data.${index}.exam`,
                                      },
                                    });
                                  }}
                                  onChange={(value) =>
                                    setFieldValue(
                                      `topper_data.${index}.exam`,
                                      value
                                    )
                                  }
                                  options={examsOptions}
                                  isLoading={coachingExamsLoading}
                                />
                                {errors[`form_${index}`]?.exam &&
                                  (touched?.topper_data?.[index]?.exam ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.exam}
                                    </div>
                                  )}

                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group
                                className="mb-3"
                                controlId="course_name"
                              >
                                <Form.Label>Course Name</Form.Label>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  name={`topper_data.${index}.course_name`}
                                  isClearable={true}
                                  getOptionLabel={(option) =>
                                    option?.course_name
                                  }
                                  getOptionValue={(option) => option?.course_id}
                                  value={
                                    values.topper_data?.[index].course_name
                                  }
                                  onInputChange={(value) =>
                                    onSearch(value, "course")
                                  }
                                  onBlur={() => {
                                    handleBlur({
                                      target: {
                                        name: `topper_data.${index}.course_name`,
                                      },
                                    });
                                  }}
                                  onChange={(value) =>
                                    setFieldValue(
                                      `topper_data.${index}.course_name`,
                                      value
                                    )
                                  }
                                  options={courseOptions}
                                  isLoading={coachingCourseDropdownListLoading}
                                />
                                {errors[`form_${index}`]?.course_name &&
                                  (touched?.topper_data?.[index]?.course_name ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.course_name}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <Form.Group
                                className="mb-3"
                                controlId="result_type"
                              >
                                <Form.Label>Result Type*</Form.Label>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  name={`topper_data.${index}.result_type`}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={
                                    values.topper_data?.[index].result_type
                                  }
                                  onBlur={() => {
                                    handleBlur({
                                      target: {
                                        name: `topper_data.${index}.result_type`,
                                      },
                                    });
                                  }}
                                  onChange={(value) =>
                                    setFieldValue(
                                      `topper_data.${index}.result_type`,
                                      value
                                    )
                                  }
                                  options={coachingToppers?.Result_type}
                                />
                                {errors[`form_${index}`]?.result_type &&
                                  (touched?.topper_data?.[index]?.result_type ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.result_type}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                            {values.topper_data?.[index].result_type?.id ===
                              1 && (
                                <Col md={6}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="rank_type"
                                  >
                                    <Form.Label>Rank Type</Form.Label>
                                    <Select
                                      className="basic-single"
                                      classNamePrefix="select"
                                      name={`topper_data.${index}.rank_type`}
                                      getOptionLabel={(option) => option.type}
                                      getOptionValue={(option) => option.id}
                                      isClearable={true}
                                      onBlur={() => {
                                        handleBlur({
                                          target: {
                                            name: `topper_data.${index}.rank_type`,
                                          },
                                        });
                                      }}
                                      value={
                                        values.topper_data?.[index].rank_type
                                      }
                                      onChange={(value) =>
                                        setFieldValue(
                                          `topper_data.${index}.rank_type`,
                                          value
                                        )
                                      }
                                      options={coachingToppers?.Rank_type}
                                    />
                                  </Form.Group>
                                </Col>
                              )}
                          </Row>
                          <Row>
                            <Col>
                              <Form.Group
                                className="mb-3"
                                controlId="result_value"
                              >
                                <Form.Label>Result Value*</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`topper_data.${index}.result_value`}
                                  className={"input_pd"}
                                  value={element.result_value}
                                  onChange={(event) =>
                                    setFieldValue(
                                      `topper_data.${index}.result_value`,
                                      event.target.value
                                    )
                                  }
                                  onBlur={handleBlur}
                                />
                                {errors[`form_${index}`]?.result_value &&
                                  (touched?.topper_data?.[index]
                                    ?.result_value ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.result_value}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group
                                className="mb-3"
                                controlId="result_year"
                              >
                                <Form.Label>Result Year*</Form.Label>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  name={`topper_data.${index}.result_year`}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.label}
                                  value={
                                    values.topper_data?.[index].result_year
                                  }
                                  onBlur={() => {
                                    handleBlur({
                                      target: {
                                        name: `topper_data.${index}.result_year`,
                                      },
                                    });
                                  }}
                                  onChange={(value) =>
                                    setFieldValue(
                                      `topper_data.${index}.result_year`,
                                      value
                                    )
                                  }
                                  options={
                                    props.dropdownConstants?.result_year_Options
                                  }
                                />
                                {errors[`form_${index}`]?.result_year &&
                                  (touched?.topper_data?.[index]?.result_year ||
                                    touchedForm == `form_${index}`) && (
                                    <div className="error">
                                      {errors[`form_${index}`]?.result_year}
                                    </div>
                                  )}
                              </Form.Group>
                            </Col>
                          </Row>
                          <h5>Image Upload</h5>
                          <Row>
                            <Col>
                              <Form.Control
                                type="file"
                                className="mb-2"
                                name={`topper_data.${index}.image`}
                                onChange={(e) => {
                                  setFieldValue(
                                    `topper_data.${index}.image`,
                                    e.currentTarget.files[0]
                                  );
                                }}
                              />
                              {typeof values?.topper_data[index]?.image == "string" &&
                                values?.topper_data[index]?.image != "" ?
                                <div className="media_image_container mt-2">
                                  <a
                                    href={values?.topper_data[index]?.image}
                                    target="_blank"
                                  >
                                    {values?.topper_data[index]?.image}
                                  </a>
                                  <span className="delete_image_btn mt-1" onClick={() => {
                                    setFieldValue(`topper_data.${index}.image`, null)
                                    dispatch(
                                      deleteCoachingOtherMedia({
                                        id: element.id,
                                        is_delete: true,
                                        media_url: values?.topper_data[index]?.image,
                                        media_type: "topper_images",
                                      })
                                    )
                                  }}>
                                    <TiDelete />
                                  </span>
                                </div>
                                : ""}
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div>Last Updated date:{element?.updated_on}</div>
                              <div>Updated by: {element?.updated_by_name}</div>
                            </Col>

                            <Col
                              md={2}
                              className="bottom_right_button_container"
                            >
                              <div className={"imageField_fieldArray"}>
                                <button
                                  onClick={(e) => {
                                    e?.preventDefault()
                                    if (
                                      Object.keys(errors[`form_${index}`])
                                        ?.length === 0
                                    ) {
                                      handleAddTopper(
                                        values?.topper_data[index],
                                        element?.id
                                      );

                                    } else {
                                      setTouchedForm(`form_${index}`);
                                    }
                                  }}
                                  className={`${"exam_button"} ${(loading || coachingToppersLoading) ? 'pe-none opacity-50' : ''}`}
                                  type="button"
                                >
                                  Save
                                </button>

                                <div className={"imageField_add"}>
                                  {values.topper_data?.length > 0 && (
                                    <span
                                      className={"imageField_minus_icon"}
                                      onClick={() => {
                                        remove(index);
                                        if (index == 0 && values.topper_data?.length == 1) {
                                          push({
                                            student_name: "",
                                            student_gender: "",
                                            exam: "",
                                            course_name: "",
                                            result_type: "",
                                            rank_type: "",
                                            result_value: "",
                                            result_year: "",
                                            image: "",
                                          });
                                        }
                                        handleRemoveTopper(
                                          values?.topper_data[index],
                                          element?.id
                                        );
                                      }}
                                    >
                                      <AiFillMinusSquare />
                                    </span>
                                  )}
                                </div>
                                <div>
                                  {index == values.topper_data?.length - 1 && (
                                    <button
                                      className={"imageField_add_icon"}
                                      onClick={() => {
                                        // if (Object.keys(errors)?.length == 0) {
                                        push({});
                                        // }
                                      }}
                                      type="submit"
                                    >
                                      <BsFillPlusSquareFill />
                                    </button>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>

                        {index == values.topper_data?.length - 1 && (
                          <Row className="mt-3">
                            <Col>
                              <button
                                onClick={handleNext}
                                className={`${"exam_button"}`}
                              >
                                Next
                              </button>
                            </Col>
                          </Row>
                        )}
                      </div>
                    ))}
                </div>
              )}
            </FieldArray>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default TopperDetailsForm;
